<script>
import accountChecklists from "../components/settings/setting-accountChecklists";
import PageHeading from "../components/global/PageHeading.vue";
import { PLAN_SKU_TYPES } from "../utils/constants";

const { FREE_PLAN, SUSPENDED_PLAN, TRIAL_PLAN } = PLAN_SKU_TYPES;

export default {
  components: {
    accountChecklists,
    PageHeading,
  },
  data() {
    return {
      steps: [
        {
          target: "#checklists_page_heading",
          content:
            "Build checklists of items approvers must confirm before they can approve a proof — useful for compliance steps or required final checks.",
          params: { placement: "bottom" },
        },
      ],
      tourCallbacks: {
        onStop: () => window.$A.SaveCompletionOfProductTours("checklists-page"),
      },
    };
  },
  computed: {
    isFreeUser() {
      const sub = _.get(this.$A, "Auth.account.subscriptionState", {});
      return sub.sku === FREE_PLAN || sub.sku === SUSPENDED_PLAN || sub.sku === TRIAL_PLAN;
    },
  },
  mounted() {
    this.$A.ClearViewData();
    window.$A.ProductTourProcess("checklists-page", this);
  },
};
</script>

<template>
  <div class="nav-margin">
    <navigation></navigation>
    <PageHeading
      anchor-id="checklists_page_heading"
      title="Checklists"
      description="Required items approvers must complete before they can approve a proof."
    />
    <accountChecklists :isPaidAccount="!isFreeUser" />
    <v-tour name="checklists-page" :steps="steps" :callbacks="tourCallbacks"></v-tour>
  </div>
</template>
